export { default } from './GridPages.vue'
